/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Theme } from '@themes/theme'
import { PureComponent } from 'react'

const Color = (theme: Theme) => css`
  .fill {
    fill: ${theme.color.themeTxt};
  }
`

export default class DownloadIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" css={Color}>
        <g id="그룹_7129" data-name="그룹 7129" transform="translate(-2337 -5092)">
          <rect id="사각형_6698" data-name="사각형 6698" width="20" height="20" transform="translate(2337 5092)" fill="#253545" opacity="0"/>
          <path id="합치기_146" className="fill" data-name="합치기 146" d="M.65,11a.649.649,0,1,1,0-1.3H7.635a.649.649,0,1,1,0,1.3ZM3.684,8.4.554,5.267a.649.649,0,0,1,.919-.918l2.02,2.02V.649a.649.649,0,0,1,1.3,0V6.368L6.813,4.349a.649.649,0,0,1,.918.918L4.6,8.4a.647.647,0,0,1-.918,0Z" transform="translate(2342.858 5096.5)" fill="#eee" stroke="rgba(0,0,0,0)" strokeMiterlimit="10" strokeWidth="1"/>
        </g>
      </svg>
    )
  }
}
